var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { ref: "checkout", staticClass: "checkout", class: _vm.stepClass },
    [
      _c("h1", { staticClass: "visually-hidden" }, [_vm._v("Checkout")]),
      _vm._v(" "),
      _c("Steps"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "checkout-container container-fluid",
          class: {
            "checkout-containerTs":
              _vm.data.brandNameFormatted === _vm.Brand.Travelsphere,
          },
        },
        [
          _c(
            "div",
            { staticClass: "checkout-row row" },
            [
              _c(
                "keep-alive",
                [
                  _vm.loading
                    ? _c("PlaneLoader", {
                        attrs: { brandName: _vm.data.brandNameFormatted },
                      })
                    : _vm.error
                    ? _c("div", { staticClass: "checkout-global-error" }, [
                        _c("div", { staticClass: "error-message" }, [
                          _c("div", { staticClass: "error-message__icon" }),
                          _vm._v(" "),
                          _c("div", { staticClass: "error-message__text" }, [
                            _c("h2", [
                              _vm._v(_vm._s(_vm.data.bookingError.title)),
                            ]),
                            _vm._v(" "),
                            _vm.quoteData.quoteId
                              ? _c("h3", [
                                  _vm._v(
                                    "Your quote id: " +
                                      _vm._s(_vm.quoteData.quoteId)
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.errorMessage
                              ? _c("p", [_vm._v(_vm._s(_vm.errorMessage))])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.data.bookingError.descriptionHtml
                                ),
                              },
                            }),
                          ]),
                        ]),
                      ])
                    : _vm._t(_vm.currentStepName),
                ],
                2
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }